Intl = require 'intl'
{ currentLocale } = require '@trello/locale'

formatter = null
module.exports = (num) ->
  formatter ?= new Intl.NumberFormat(currentLocale)
  formatter.format(num)



// WEBPACK FOOTER //
// ./app/scripts/lib/format/number.coffee